
  import * as fabIcons from './classic/brands.mjs';

  import * as falIcons from './classic/light.mjs';

  import * as farIcons from './classic/regular.mjs';

  import * as fasIcons from './classic/solid.mjs';

  import * as fakIcons from './kit/custom.mjs';

  


var byPrefixAndName = {'fab': {},'fal': {},'far': {},'fas': {},'fak': {},};
var all = [];

function addIcons (icons) {
  Object.keys(icons).forEach(function (iconName) {
    if (iconName === 'prefix') {
      return;
    }

    var icon = icons[iconName];
    var aliases = icon.icon[2];
    aliases.forEach(function (alias) {
      if (typeof alias === 'string') {
        byPrefixAndName[icon.prefix][alias] = icon;
      }
    })
    byPrefixAndName[icon.prefix][icon.iconName] = icon;
    all.push(icon);
  });
}


  
  addIcons(fabIcons);
  var fab = fabIcons;
  

  
  addIcons(falIcons);
  var fal = falIcons;
  

  
  addIcons(farIcons);
  var far = farIcons;
  

  
  addIcons(fasIcons);
  var fas = fasIcons;
  

  
  addIcons(fakIcons);
  var fak = fakIcons;
  

  


export {
  byPrefixAndName, all
  , fab, fal, far, fas, fak
}
